import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { getDisplayName } from 'gandi.react-helpers';
import { makeWrapHandler } from '../utils';
import { AssetPathContext } from '../context/AssetPathContext';

/**
 * Add an `assetPath` props to the decorated component.
 * @example
 * ```js
 * const Decorated = withAssetPath<typeof SomeComponent>(SomeComponent);
 * ```
 */
var withAssetPath = function withAssetPath(WrappedComponent) {
  function WithAssetPathWrapper(props) {
    var assetpath = React.useContext(AssetPathContext);
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      assetPath: assetpath
    }));
  }

  WithAssetPathWrapper.displayName = "WithAssetPath(".concat(getDisplayName(WrappedComponent), ")");
  WithAssetPathWrapper.WrappedComponent = WrappedComponent;
  var HoistedComponent = hoistNonReactStatic(WithAssetPathWrapper, WrappedComponent);
  var wrapHandler = makeWrapHandler(WrappedComponent, HoistedComponent, function (wrappedHandler) {
    return function (props) {
      var assetPath = props.res.locals.assetPath;

      var wrapperComponentProps = _objectSpread({}, props); // add assetPath function to renderProps


      wrapperComponentProps.renderProps = _objectSpread(_objectSpread({}, props.renderProps), {}, {
        assetPath: assetPath
      });

      for (var _len = arguments.length, extra = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        extra[_key - 1] = arguments[_key];
      }

      return wrappedHandler.apply(void 0, [wrapperComponentProps].concat(extra));
    };
  });
  wrapHandler('preFetch');
  wrapHandler('handleRedirect');
  wrapHandler('handleForm');
  wrapHandler('handlePageMeta');
  return HoistedComponent;
};

export default withAssetPath;